import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("numero", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.numero + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_desde", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.fecha_desde + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_hasta", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.fecha_hasta + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("dias", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.dias + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("tipo", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.tipo + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("estado", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.estado + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_solicitud", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.fecha_solicitud + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("nombres", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombres + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("nombre_unidad", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombre_unidad + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });

            return cf.runFilters();
        },
        filterNumero(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                numero: val
            });
        },
        filterFechaDesde(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_desde: val
            });
        },
        filterFechaHasta(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_hasta: val
            });
        },
        filterDias(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                dias: val
            });
        },
        filterTipo(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                tipo: val
            });
        },
        filterEstado(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: val
            });
        },
        filterFechaSolicitud(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_solicitud: val
            });
        },
        filterNombres(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombres: val
            });
        },
        filterNombreUnidad(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_unidad: val
            });
        },
        //-------------------------------------
        recargar() {
            this.form = {}
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                numero: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_desde: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_hasta: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                dias: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                tipo: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_solicitud: ""
            }); 
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombres: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_unidad: ""
            });
            
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/vacacion_rrhh/mixins/FiltrosVacacion.js